import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import AutorenewOutlinedIcon from "@material-ui/icons/AutorenewOutlined";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import CheckOutlinedIcon from "@material-ui/icons/CheckOutlined";
import HourglassEmptyOutlinedIcon from "@material-ui/icons/HourglassEmptyOutlined";

const useStyles = makeStyles((theme) => ({
  runningIcon: {
    color: theme.palette.KenColors.tertiaryOrange50,
  },
  cancelIcon: {
    color: theme.palette.KenColors.tertiaryRed200,
  },
  successIcon: {
    color: theme.palette.KenColors.tertiaryGreen200,
  },
  pendingIcon: {
    color: theme.palette.KenColors.neutral100,
  },
  statusLabel: {
    marginLeft: 16,
    fontSize: 14,
    [theme.breakpoints.down("xs")]: {
      fontSize: 12,
    },
  },
}));

export default function FileUploadStatus(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { value } = props;

  const uploadStatus = (value) => {
    switch (value) {
      case "running":
        return (
          <>
            <AutorenewOutlinedIcon className={classes.runningIcon} />
            <Typography className={classes.statusLabel}>{value}</Typography>
          </>
        );
      case "failed":
        return (
          <>
            <CancelOutlinedIcon className={classes.cancelIcon} />
            <Typography className={classes.statusLabel}>{value}</Typography>
          </>
        );
      case "completed":
        return (
          <>
            <CheckOutlinedIcon className={classes.successIcon} />
            <Typography className={classes.statusLabel}>{value}</Typography>
          </>
        );
      default:
        return (
          <>
            <HourglassEmptyOutlinedIcon className={classes.pendingIcon} />
            <Typography className={classes.statusLabel}>{value}</Typography>
          </>
        );
    }
  };

  return (
    <Grid className={classes.root}>
      <div style={{ display: "flex", alignItems: "center" }}>
        {uploadStatus(value)}
      </div>
    </Grid>
  );
}
